import AccountService from "@/services/api/account.service";
import { TokenService } from "@/services/storage.service";

const user = {
  accessToken: null,
  refreshToken: null,
};

const detail = {
  userId: "",
  fullName: "",
};

const initialState = {
  detail: { ...detail },
  userId: "",
  user: { ...user },
  permissionMenu: [],
  userBrands: [],
};

const actions = {
  login({ commit }, data) {
    return AccountService.login(data).then(
      (res) => {
        console.log("actions login:res", res);
        const user = {
          accessToken: res.data.access_token,
          refreshToken: res.data.refresh_token,
        };

        commit("loginSuccess", user);
        commit("setUserId", res.data.userId);
        commit("setUserDetail", res.data.dataUser);
        commit("setPermissionMenu", res.data.roles);
        commit("setUserBrands", res.data.brands);

        return res;
      },
      (error) => {
        commit("loginFailure");
        throw error;
      }
    );
  },
  logout({ commit }) {
    return AccountService.logout().then(
      (res) => {
        commit("logoutSuccess");
        return res;
      },
      (error) => {
        commit("logoutFailure");
        throw error;
      }
    );
  },
  refresh({ commit }) {
    return AccountService.refreshToken().then(
      (res) => {
        commit("loginSuccess", res);
        return res;
      },
      (error) => {
        commit("loginFailure");
        throw error;
      }
    );
  },
  changepassword({ commit }, data) {
    return AccountService.changepassword(data).then(
      (res) => {
        return res;
      },
      (error) => {
        commit("loginFailure");
        throw error;
      }
    );
  },
};

const mutations = {
  loginSuccess(state, user) {
    state.user = user;
  },
  loginFailure(state) {
    state.user = {};
  },
  logoutSuccess(state) {
    state.user = {};
    state.detail = {};
    state.userId = "";
    state.permissionMenu = [];
    state.userBrands = [];
  },
  logoutFailure(state) {
    state.user = {};
    state.detail = {};
    state.userId = "";
    state.permissionMenu = [];
    state.userBrands = [];
  },
  saveLocalToken(state) {
    console.log("saveLocalToken: ", state.user);
    if (state.user?.accessToken && state.user?.refreshToken) {
      TokenService.saveToken(state.user.accessToken);
      TokenService.saveRefreshToken(state.user.refreshToken);
    } else {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
    }
  },
  setUserId(state, userId) {
    state.userId = userId;
  },
  setUserDetail(state, userDetail) {
    state.detail = { ...userDetail };
  },
  setPermissionMenu(state, menu) {
    if (menu) {
      state.permissionMenu = menu;
      TokenService.saveUserRoles(JSON.stringify(menu));
    } else {
      state.permissionMenu = [];
    }
  },
  setUserBrands(state, brands) {
    if (brands) {
      state.userBrands = brands;
      TokenService.saveUserBrands(JSON.stringify(brands));
    } else {
      state.userBrands = [];
    }
  },
};

const getters = {
  getUserRoles() {
    return JSON.parse(localStorage.getItem("user_roles"));
  },
};

export const account = {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};
